import type { Action } from 'redux';

export const CHANGE_READY_FOR_SAVE = 'CHANGE_READY_FOR_SAVE';
export const changeReadyForSave = (isReady: boolean): ChangeReadyForSaveAction => {
  return {
    type: CHANGE_READY_FOR_SAVE,
    data: isReady,
  };
};

export type ChangeReadyForSaveAction = Action<typeof CHANGE_READY_FOR_SAVE> & { data: boolean };
